import { useState, useEffect, useCallback } from "react";

const moveOutPhotos = [
  {
    before:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/8e84938ee305dab032f615b881bf293a.jpeg",
    after:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/7264715db7f563a1d4ced86463c4c04e.jpeg",
  },
  {
    before:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/e8dd538edde4e48917d7954261c39a62.jpeg",
    after:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/3ee99f41b5d99dc680d40b524550c086.jpeg",
  },
  {
    before:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/c8c5728009ba98ac8c1bc5427bd82d6c.jpeg",
    after:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/fac283c509860a5ef67134a8a448955e.jpeg",
  },
  {
    before:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/c84aedb9e5244caaaf036d92e3da2555.jpeg",
    after:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/f1760cf011d9cefb63b4838d39819843.jpeg",
  },
  {
    before:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/eccb89fc45e696ad6c7bd4b2871c8857.jpeg",
    after:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/4c959b46e3f2dea0390ae8387a3587b8.jpeg",
  },
];

const specialPhotos = [
  {
    before:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/5e4d1f61-45bf-49e3-ab7a-2cceaa7c6399_1.1.jpg?v=19b4d01959e347b9816ef82cd96753a2",
    after:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/8dfeee10-93d4-4234-b63e-34372d5d7fcb_1.2.jpg?v=c28158fdfe944631217374292f711a53",
  },
  {
    before:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/1bb0ed35-5ff1-4e68-a54f-eeab4d5422f6_2.1.jpg?v=17fa493c0e8074d59bdadf71e2e35e43",
    after:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/21a9f8ed-f526-4fdb-867c-91500d019564_2.2.jpg?v=392396e90a69185f14027e301d77af8a",
  },
  {
    before:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/4b5129ce-a9c2-4805-97d0-3dfb217db32f_3.1.jpg?v=c0331f731f732f6493497ec545e51fd6",
    after:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/15869e21-05f4-4692-b038-7077704a1b4d_3.2.jpg?v=13a6208b9326e1145014a0b4b5fc7649",
  },
  {
    before:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/9d8652a5-b346-4ec5-8af6-373cb57b72c2_4.1.jpg?v=b96fafcd7232ca6b7fbcdec5f67b1097",
    after:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/39d3a870-ce86-4898-844f-930bd46d9532_4.2.jpg?v=b94a929a3df05cd620eea82ea7c5a3aa",
  },
  {
    before:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/51016660-9e79-419c-bd13-2a63f6645a92_5.1.jpg?v=3add0cfeed596ad31d0bb6450f8ac03e",
    after:
      "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/ef8f931d-8275-4d37-ad9b-a490892c358b_5.2.jpg?v=503821b0eee93a700dd619ba12a69d77",
  },
];

const estatePhotos = [
  {
    before:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/1cabfd65da5a48dc7433c18b607dfab6.jpeg",
    after:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/de6064e0215181d3bed8d35cc873108c.jpeg",
  },
  {
    before:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/eb79d3d108d809d9da768b241f4c1fe7.jpeg",
    after:
      "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/86e7415ad18697595fa315a7e56a789e.jpeg",
  },
];

const servicePhotos: Record<number, { before: string; after: string }[]> = {
  1: moveOutPhotos,
  2: specialPhotos,
  3: estatePhotos,
};

const services = [
  {
    id: 1,
    title: "퇴실 청소",
    subtitle: "이사 · 이민 · 퇴거",
    description:
      "이사, 이민, 퇴거로 인해 집을 비워야 하는 경우, 불필요한 물품을 신중히 처리한 후 집안 소독·청소·복구 작업을 진행합니다.",
    icon: "ri-door-open-line",
    features: ["불필요 물품 신중 처리", "집안 꼼꼼 소독", "퇴거 전 꼼꼼 정리"],
    badge: "인기",
    color: "amber",
    hasPhotos: true,
  },
  {
    id: 2,
    title: "특수 청소",
    subtitle: "쓰레기집 · 악취 제거 · 소독",
    description:
      "쓰레기를 버리지 못해 집에 쌓아둔 경우, 쓰레기 수거 후 악취 제거와 소독을 진행합니다. 비대면 신청이 가능하며, 작업 과정에서도 개인정보를 철저히 보호하고 조용히 진행합니다.",
    icon: "ri-shield-check-line",
    features: ["비대면 신청 가능", "쓰레기 꼼꼼 수거", "악취 꼼꼼 제거", "개인정보 철저 보호"],
    badge: "비대면",
    color: "green",
    hasPhotos: true,
  },
  {
    id: 3,
    title: "유품 정리",
    subtitle: "고독사 · 사망 후 정리",
    description:
      "고독사, 사망으로 인한 물품 정리 서비스입니다. 폐기물을 적법하게 처리하고 집안을 정리합니다. 유가족의 마음을 헤아려 조심스럽고 정중하게 진행합니다.",
    icon: "ri-heart-line",
    features: ["폐기물 적법 처리", "유품 정중히 정리", "집안 꼼꼼 청소", "유가족 배려 진행"],
    badge: null,
    color: "rose",
    hasPhotos: true,
  },
];

const badgeColors: Record<string, string> = {
  인기: "bg-amber-500 text-white",
  비대면: "bg-green-500 text-white",
};

const activeColors: Record<string, string> = {
  amber: "bg-amber-500 text-white",
  green: "bg-green-500 text-white",
  rose: "bg-rose-500 text-white",
};

export default function ServicesSection() {
  const [activeId, setActiveId] = useState(1);
  const [photoIdx, setPhotoIdx] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIdx, setModalIdx] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);

  const currentPhotos = servicePhotos[activeId] ?? [];

  useEffect(() => {
    setPhotoIdx(0);
  }, [activeId]);

  useEffect(() => {
    if (currentPhotos.length === 0) return;
    const timer = setInterval(() => {
      setPhotoIdx((prev) => (prev + 1) % currentPhotos.length);
    }, 2000);
    return () => clearInterval(timer);
  }, [activeId, currentPhotos.length]);

  const openModal = useCallback((idx: number) => {
    setModalIdx(idx);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => setIsModalOpen(false), []);

  const prevSet = useCallback(() => {
    setModalIdx(
      (prev) =>
        (prev - 1 + currentPhotos.length) % currentPhotos.length
    );
  }, [currentPhotos.length]);

  const nextSet = useCallback(() => {
    setModalIdx((prev) => (prev + 1) % currentPhotos.length);
  }, [currentPhotos.length]);

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStartX(e.changedTouches[0].clientX);
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    const delta = e.changedTouches[0].clientX - touchStartX;
    if (delta > 50) prevSet();
    else if (delta < -50) nextSet();
  };

  return (
    <section id="services" className="py-24 bg-stone-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-700 text-sm font-medium px-4 py-2 rounded-full mb-4">
            <i className="ri-sparkling-line"></i>
            <span>전문 청소 서비스</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">우리의 의무</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            퇴실청소, 특수청소, 유품정리 — 남들이 꺼리는 일을 우리가 합니다
          </p>
        </div>

        <div className="flex flex-col gap-6">
          {services.map((svc) => {
            const isActive = activeId === svc.id;
            const photos = servicePhotos[svc.id] ?? [];
            const safePhotoIdx = photos.length > 0 ? Math.min(photoIdx, photos.length - 1) : 0;
            const photoSet = photos[safePhotoIdx];
            return (
              <div key={svc.id} className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
                <div
                  onClick={() => setActiveId(svc.id)}
                  className={`relative p-6 cursor-pointer transition-all duration-300 ${
                    isActive ? "bg-white" : "bg-white/60 hover:bg-white"
                  }`}
                >
                  {svc.badge && (
                    <span
                      className={`absolute top-4 right-4 text-xs font-bold px-2.5 py-1 rounded-full ${
                        badgeColors[svc.badge] ?? "bg-gray-200 text-gray-700"
                      }`}
                    >
                      {svc.badge}
                    </span>
                  )}
                  <div className="flex items-start gap-4">
                    <div
                      className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${
                        isActive ? activeColors[svc.color] : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      <i className={`${svc.icon} text-xl`}></i>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h3 className="text-lg font-bold text-gray-900">{svc.title}</h3>
                        <span className="text-xs text-gray-400">{svc.subtitle}</span>
                      </div>
                      <p className="text-sm text-gray-500 leading-relaxed">{svc.description}</p>
                    </div>
                    <div className="flex items-center self-center">
                      <i
                        className={`ri-arrow-down-s-line text-xl text-gray-400 transition-transform duration-300 ${
                          isActive ? "rotate-180" : ""
                        }`}
                      ></i>
                    </div>
                  </div>
                </div>

                {isActive && photos.length > 0 && photoSet && (
                  <div className="px-6 pb-6 pt-2 border-t border-gray-50">
                    <div>
                      <div
                        className="grid grid-cols-2 gap-2 mb-4"
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                      >
                        <div
                          className="relative rounded-xl overflow-hidden cursor-pointer"
                          onClick={() => openModal(safePhotoIdx)}
                        >
                          <div className="aspect-[3/4]">
                            <img
                              src={photoSet.before}
                              alt="청소 전"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <span className="absolute top-3 left-3 bg-red-500/90 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                            청소 전
                          </span>
                        </div>
                        <div
                          className="relative rounded-xl overflow-hidden cursor-pointer"
                          onClick={() => openModal(safePhotoIdx)}
                        >
                          <div className="aspect-[3/4]">
                            <img
                              src={photoSet.after}
                              alt="청소 후"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <span className="absolute top-3 left-3 bg-green-500/90 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                            청소 후
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center justify-center gap-2 mb-4">
                        {photos.map((_, idx) => (
                          <button
                            key={idx}
                            onClick={() => setPhotoIdx(idx)}
                            className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                              idx === safePhotoIdx ? "bg-amber-500 w-6" : "bg-gray-300 w-2"
                            }`}
                          />
                        ))}
                      </div>
                      <p className="text-center text-xs text-gray-400 mb-4">
                        사진을 탭하면 확대해서 볼 수 있어요
                      </p>
                      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
                        {svc.features.map((f) => (
                          <div
                            key={f}
                            className="flex items-center gap-1.5 text-sm text-gray-600 bg-gray-50 rounded-lg px-3 py-2"
                          >
                            <i className="ri-check-line text-amber-500 text-base"></i>
                            <span>{f}</span>
                          </div>
                        ))}
                      </div>
                      <div className="flex justify-center">
                        <a
                          href="tel:01055608051"
                          className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
                        >
                          <i className="ri-phone-line"></i>
                          <span>전화 상담하기</span>
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Photo Modal */}
      {isModalOpen && currentPhotos.length > 0 && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex flex-col"
          onClick={closeModal}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-4 py-3 flex-shrink-0">
            <span className="text-white text-sm font-medium">
              {modalIdx + 1} / {currentPhotos.length}
            </span>
            <button
              onClick={closeModal}
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-white text-2xl"></i>
            </button>
          </div>

          {/* Images */}
          <div
            className="flex-1 flex items-center justify-center relative overflow-hidden px-1"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                prevSet();
              }}
              className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-white text-2xl"></i>
            </button>

            {(() => {
              const set = currentPhotos[modalIdx];
              if (!set) return null;
              return (
                <div className="flex w-full h-full gap-1 sm:gap-2 max-h-[80vh]">
                  <div className="flex-1 relative flex items-center justify-center">
                    <img
                      src={set.before}
                      alt="청소 전"
                      className="max-w-full max-h-full object-contain rounded-lg"
                    />
                    <span className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                      청소 전
                    </span>
                  </div>
                  <div className="flex-1 relative flex items-center justify-center">
                    <img
                      src={set.after}
                      alt="청소 후"
                      className="max-w-full max-h-full object-contain rounded-lg"
                    />
                    <span className="absolute top-2 left-2 bg-green-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                      청소 후
                    </span>
                  </div>
                </div>
              );
            })()}

            <button
              onClick={(e) => {
                e.stopPropagation();
                nextSet();
              }}
              className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-white text-2xl"></i>
            </button>
          </div>

          {/* Indicators */}
          <div className="flex justify-center gap-2 py-4 flex-shrink-0">
            {currentPhotos.map((_, idx) => (
              <button
                key={idx}
                onClick={(e) => {
                  e.stopPropagation();
                  setModalIdx(idx);
                }}
                className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  idx === modalIdx ? "bg-amber-400 w-6" : "bg-white/40 w-2"
                }`}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}